export const apiKey = 'YXBpOjEyMWIzMTRjnDdKOaVlOTa3NTk0ZjdmYjJhNzGzmjc4NDM2YWM4NjdjMTK4NmIwNTBkYTY1YjhiOTRiMWU4YWY=';
export const sessionToken = 'a7dcfa5479ac3bf349caa1336b312336094b5e715abadd112df2e0c1f42dd0fcc0d0656ae6ff19c35e5475f9cf05993f400e0cfe';
export const mfaToken = '6d8d3098b3fd4ffab4f417458969a98d757f1a6de59bb4a32d20122b9d684dad';
